import React, { useEffect, useState } from 'react';
import { Box, Input as ChakraInput, InputProps, FormLabel } from '@chakra-ui/react';

interface DateTimeInputProps extends Omit<InputProps, 'value' | 'onChange'> {
  value?: string;
  onChange?: (date: Date | null) => void;
  placeholder?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  variant?: string;
  backgroundColor?: string;
  inputTextColor?: string;
  placeholderColor?: string;
  label?: string;
  labelColor?: string;
  labelSize?: string;
  marginTop?: string;
}

export const CustomDateTimePicker: React.FC<DateTimeInputProps> = ({
  value,
  onChange,
  placeholder,
  isDisabled,
  isRequired,
  isInvalid,
  variant = 'outline',
  backgroundColor = '#fff',
  inputTextColor = '#000',
  placeholderColor = '#A0AEC0',
  label,
  labelColor,
  labelSize,
  marginTop,
  ...inputProps
}) => {
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value || '');
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setLocalValue(val);
    onChange?.(val ? new Date(val) : null);
  };

  return (
    <Box width="100%" shadow="none" marginTop={marginTop}>
      {label && (
        <FormLabel color={labelColor} fontSize={labelSize} fontWeight="bold">
          {label}
        </FormLabel>
      )}
      <ChakraInput
        type="datetime-local"
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isRequired={isRequired}
        isInvalid={isInvalid}
        variant={variant}
        backgroundColor={backgroundColor}
        color={inputTextColor}
        _placeholder={{ color: placeholderColor }}
        height={inputProps.height}
        width={inputProps.width}
        paddingLeft={inputProps.paddingLeft}
        fontSize={inputProps.fontSize}
        textOverflow={inputProps.textOverflow}
        mt={marginTop}
      />
    </Box>
  );
};
